module.exports = __webpack_public_path__ + "img/logo.d288c075.png";